import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SupplierService } from '../supplier/services/supplier.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IRFQAttachment, IRFQBuyer, IRFQSupplier, IRFQTemplateDetail } from '../pr-buyer/models';
import { SupplierHelperService } from '../supplier/services/supplier-helper.service';
import { AuthService } from '../core/services/auth/auth.service';
import { TabService } from '../shared/services/tab.service';
import { RfqService } from '../pr-buyer/services/rfq/rfq.service';
import { PrBuyerHelperService } from '../pr-buyer/services/pr-buyer-helper.service';
import { AdminService } from '../admin/services/admin.service';
import { Subject, fromEvent, takeUntil } from 'rxjs';

interface FileSize {
  file : File,
  formatSize : string
}

@Component({
  selector: 'app-unregistered',
  templateUrl: './unregistered.component.html',
  styleUrls: ['./unregistered.component.scss']
})
export class UnregisteredComponent implements OnInit {

  public rfqForm !: FormGroup;
  public rfqTemplate !: IRFQTemplateDetail;
  public rfqSupplier!: IRFQSupplier;
  public rfqBuyer !: IRFQBuyer;
  public uploadedFiles: IRFQAttachment[] = [];
  public userDetails: any;
  public isQuotationSubmitted !: boolean;
  public displayStyle = "none";
  public currencyList !: any;
  public isDisabled: boolean = false;
  quotationsData: any;
  selectedFiles?: File;
  progressInfos: any[] = [];
  message: string[] = [];
  previews: string[] = [];
  unregisteredData: any;
  finallineItemData: any;
  private unsubscriber : Subject<void> = new Subject<void>();

  constructor(private _toastr: ToastrService, private _authService: AuthService,
    private formBuilder: FormBuilder, private _adminService: AdminService,
    private service: TabService,
    private router: Router,
    private _helperService: PrBuyerHelperService,
    private _supplierService: SupplierService,
    private _supplierHelperService: SupplierHelperService,
    private _activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private _rfqService: RfqService,) {
    this.rfqForm = this.formBuilder.group({
      template_name: '', rfq_date: '', rfq_time: '', buyer: '', email: '', payment_term: '', siemens_qt_deadline: '', date: '', mobile_no: '',
      vendor_payment_terms: '', vendor_incoterms_2: '', vendor_tax_applicable: '', 
      sales_person_number:['', [Validators.required, Validators.pattern(/^\d{10}$/)]], contact_number: '',
      vendor_incoterms_1: '', vendor_delivery_date: '', sales_person_name: '', city: '', country: '', create_date_time: '',
      name: '', siemens_make: '', siemens_model: '', hsn_or_sac: '', item_desc: '', uom: '', quantity: '', unit_price: '', tax: '',
      lead_time: '', remark: '', rfq_template_id: '', line_item_id: '', total_price: '', freight_charge: '',quotation:'',
      purchase_order_currency: '', freight_percent_or_amount: '', packing_charge: '', packing_percent_or_amount: '',
      quotationDetails: this.formBuilder.array([this.initRows()])
    });
  }

  ngOnInit() {
    this.fetchRFQDetails();
    this.getCurrencyList()
    this.fetchRFQTemplates();
    this.populateFormArray(this.quotationsData);

    history.pushState(null, '');
    fromEvent(window, 'popstate').pipe(
      takeUntil(this.unsubscriber)
    ).subscribe((_) => {
      history.pushState(null, '');
      this._toastr.error(`You can't make changes or go back at this time.`);
    });
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  public initRows() {
    return this.formBuilder.group({
      id: '', name: '', siemens_make: '', siemens_model: '', hsn_or_sac: '', material_code:'', item_desc: '', uom: '', quantity: '', unit_price: '', tax: '',
      lead_time: '', remark: '', rfq_template_id: '', line_item_id: '', total_price: '', freight_charge: '',
      purchase_order_currency: '', freight_percent_or_amount: '', packing_charge: '', packing_percent_or_amount: '',
    });
  }

get formArr(): FormArray {
  return this.rfqForm.get('quotationDetails') as FormArray;
}

public populateFormArray(data: any[]): void {
  const quotationDetailsArray = this.rfqForm.get('quotationDetails') as FormArray;
  quotationDetailsArray.clear(); // Clear any existing rows
 
  if (data && data.length > 0) {
  data.forEach(item => {
    this.formArr.push(this.formBuilder.group({
      id: [item.id],
      name: [item.name],
      siemens_make: [item.siemens_make],
      siemens_model: [item.siemens_model],
      hsn_or_sac: [item.hsn_or_sac],
      item_desc: [item.line_item_id.item_desc],
      uom: [item.uom],
      material_code: [item.line_item_id.material_code],
      quantity: [item.quantity],
      unit_price: [item.unit_price],
      tax: [item.tax],
      lead_time: [item.lead_time],
      remark: [item.remark],
      rfq_template_id: [item.rfq_template_id],
      line_item_id: [item.line_item_id],
      total_price: [item.total_price],
      freight_charge: [item.freight_charge],
      purchase_order_currency: [item.purchase_order_currency],
      freight_percent_or_amount: [item.freight_percent_or_amount],
      packing_charge: [item.packing_charge],
      packing_percent_or_amount: [item.packing_percent_or_amount],
    }));
  });
}
this.cdr.detectChanges();
}

  public fetchRFQDetails() {
    this.service.currentData.subscribe(data => {
      this.unregisteredData = data[0];
      this.rfqTemplate = this.unregisteredData;
      this.rfqBuyer = this.unregisteredData.buyer_id;
      this.rfqSupplier = this.unregisteredData.un_reg_vendor;
      this.quotationsData = this.unregisteredData.quotations;
    });
  }

  filteringUnregisteredData() {
    const fields = ['siemens_make', 'siemens_model', 'hsn_or_sac', 'id', 'uom', 'quantity', 'unit_price', 'tax', 'lead_time', 'remark',
      'total_price', 'purchase_order_currency', 'freight_charge', 'freight_percent_or_amount', 'packing_charge', 'packing_percent_or_amount'];

    const lineItemField = ['item_desc', 'material_master_id'];

    this.finallineItemData = this.formArr.controls.map((item:any) => {
      const quotationDetails = Object.fromEntries(fields.map((field) => [field, item.value[field]]));
      const itemDescData = Object.fromEntries(lineItemField.map((field) => [field, item.value.line_item_id[field]]));
      const rfqTemplateId = { rfq_template_id: item.value.rfq_template_id['id'] }; // Adjusted to access 'id' with square brackets

      const mergedData: Record<string, any> = Object.assign({}, quotationDetails, itemDescData, rfqTemplateId);
      mergedData['line_item_id'] = mergedData['material_master_id'];
      delete mergedData['material_master_id'];

      return mergedData;
    });
  }
  

  onSubmit() {
    this.filteringUnregisteredData();
    let body = {
      id: this.unregisteredData.id,
      template_name: this.rfqForm.getRawValue().template_name,
      buyer_id: this.unregisteredData.buyer_id.id,
      supplier_id: this.unregisteredData.supplier_id,
      prId: this.unregisteredData.prId.prId,
      vendor_payment_terms: this.rfqForm.getRawValue().vendor_payment_terms,
      vendor_tax_applicable: this.rfqForm.getRawValue().vendor_tax_applicable,
      vendor_delivery_date: this.rfqForm.getRawValue().vendor_delivery_date,
      vendor_seal_or_sig: this.unregisteredData.vendor_seal_or_sig,
      vendor_incoterms_1: this.rfqForm.getRawValue().vendor_incoterms_1,
      vendor_incoterms_2: this.rfqForm.getRawValue().vendor_incoterms_2,
      sales_person_name: this.rfqForm.getRawValue().sales_person_name,
      sales_person_number: this.rfqForm.getRawValue().sales_person_number,
      quotation_details: this.finallineItemData
    }
    this._supplierService.saveUnregisteredRFQQuotations(body).subscribe((res: any) => {
      this._toastr.success("RFQ Quotation updated!");
      this.displayStyle = "block";
    });
    this._authService.clearAllStorage();
  }

  selectFiles(event: any): void {
    this.message = [];
    this.progressInfos = [];
    console.log("event.target.files[0]?.size", event.target.files[0]?.size)
    const size = event.target.files[0]?.size;
    this.previews = [];
    if (size <= 500000) {
      this.selectedFiles = event.target.files[0];
      if (this.selectedFiles && this.selectedFiles) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.previews.push(e.target.result);
        };

        reader.readAsDataURL(this.selectedFiles);
      }
    } else {
      this._toastr.error("Please upload the signature size within 500 KB!");
    }
  }

  public getCurrencyList() {
    this._adminService.getCurrency().subscribe((res: any) => {
      this.currencyList = res.data.map((currency: any) => currency.code);
    })
  }

  private fetchRFQTemplates(): void {
    this._rfqService.fetchRFQTemplateAttachments(this.rfqTemplate?.id).subscribe((res: any) => {
      this.uploadedFiles = res.data;
    })
  }

  public downloadRFQtemplate(prFile: IRFQAttachment): void {
    this._rfqService.downloadRFQTemplateAttachment(prFile.id).subscribe((res: any) => {
      this._helperService.saveFileData(res, prFile.name);
    });
  }

  public deleteRFQtemplate(prFile: IRFQAttachment): void {
    this._rfqService.deletedRFQTemplateAttachment(prFile?.id).subscribe((res: any) => {
      this.fetchRFQTemplates();
    });
  }

  public uploadAttachment() {
    const modalRef = this._supplierHelperService.uploadSupplierRfQAttachment(this.rfqTemplate?.id);
    modalRef.subscribe((res: any) => {
      if (res) {
        this.fetchRFQTemplates();
      }
    });
  }
}


